'use client';

import dynamic from 'next/dynamic';

// 01
export const SingleClick = dynamic(
  () => import('./instances/SingleClick')
);
// 02
export const RenderPileUp = dynamic(
  () => import('./instances/RenderPileUp')
);
// 03
export const SingleClickDeferred = dynamic(
  () => import('./instances/SingleClickDeferred')
);
// 04
export const DeferredWorkingPerfectly = dynamic(
  () => import('./instances/DeferredWorkingPerfectly')
);

export const RenderEventMagicSchoolBus = dynamic(
  () => import('./RenderEventMagicSchoolBus')
);
